<template>
  <div style="width: 100%; height: 260px; margin: 0 auto;" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
import { getDateAndHour } from '@/utils/updateTime.js'
import { thousandFn } from '@/utils/thousandFn.js'
var colorList = [
  '#30c7c9', '#b6a2de', '#59b1ef', '#f49530',
  '#d87980', '#8c98b3', '#e5ce2c', '#97b552',
  '#996666', '#cc6699', '#339999', '#9966cc',
  '#6699cc', '#ff9933', '#cc6666', '#666699'
]
export default {
  mixins: [resize],
  props: {
    width: {
      type: String,
      default: '98%'
    },
    height: {
      type: String,
      default: '300px'
    },
    lineDate: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null,
      series: {
        dataDate: [], // 日期
        onlineRateDate: [], // 联网率
        deviceCountDate: [], // 设备数量
        onlineCountDate: [] // 联网数量
      }
    }
  },
  watch: {
    lineDate: {
      handler(newValue, oldValue) {
        this.lineDate = newValue // 把新值赋值给我们的属性数据
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.xAxisDate = []
      this.legendDate = []
      this.series = {
        dataDate: [], // 日期
        onlineRateDate: [], // 联网率
        deviceCounteDate: [], // 设备数量
        onlineCounteDate: [] // 联网数量
      }
      this.lineDate.forEach(v => {
        if (v.summaryTime) this.series.dataDate.push(getDateAndHour(v.summaryTime, 'onlyMonthAndDay'))
        // if (v.onlineRate) this.series.onlineRateDate.push(v.onlineRate * 100)
        if (v.onlineRate || v.onlineRate == 0) {
          this.series.onlineRateDate.push({ value: v.onlineRate * 100, deviceCount: v.deviceCount, onlineCount: v.onlineCount, activeCnt: v.activeCnt })
        }
        if (v.deviceCount || v.deviceCount == 0) this.series.deviceCounteDate.push(v.deviceCount)
        if (v.onlineCount || v.onlineCount == 0) this.series.onlineCounteDate.push(v.onlineCount)
      })
    console.log(this.series.onlineRateDate)
      this.chart = echarts.init(this.$el, 'macarons')
      const that = this;
      var option = {
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'axis',
          formatter: function(params, ticket, callback) {
            var htmlStr = ''
            for (var j = 0; j < params.length; j++) {
              var param = params[j]
              // console.log('param----', param)
              // 隐藏某一类型时,param为undefined
              var xName = param ? param.name : ''// x轴的名称
              var seriesName = param ? param.seriesName : ''// 图例名称
              var value = param ? param.value : ''// y轴值
              // var color = param ? param.color : ''// 图例颜色

              if (j === 0) {
                htmlStr += xName + '<br/>'// x轴的名称
              }
              htmlStr += '<div>'
              // 圆点
              // if (param) {
              //   // 圆点后面显示的文本
              //   if (param.seriesIndex == 0) { // 联网率
              //     htmlStr += seriesName + '：' + value + '%'
              //   } else {
              //     value = thousandFn(value) || '--'
              //     htmlStr += seriesName + '：' + value
              //   }
              // }
              if (param.data.value) {
                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + colorList[0] + ';"></span>'
                htmlStr += that.$t('AllDevices.connectivityHealth2') + '：' + Math.round(value) + '%' + '<br>'
              }
              if (param.data.deviceCount) {
                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + colorList[1] + ';"></span>'
                value = thousandFn(param.data.deviceCount) || '--'
                htmlStr += that.$t('AllDevices.NumberOfDevices') + '：' + value + '<br>'
              }
              if (param.data.activeCnt) {
                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + colorList[3] + ';"></span>'
                value = thousandFn(param.data.activeCnt) || '--'
                htmlStr += that.$t('AllDevices.ActiveDevices') + '：' + value + '<br>'
              }
              if (param.data.onlineCount) {
                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + colorList[2] + ';"></span>'
                value = thousandFn(param.data.onlineCount) || '--'
                htmlStr += that.$t('AllDevices.NumberOfConnected') + '：' + value
              }
              htmlStr += '</div>'
            }
            return htmlStr
          },
          position: function(p) { // 其中p为当前鼠标的位置
            return [p[0] + 10, p[1] - 10]
          },
          textStyle: {
            align: 'left'
          }
        },
        grid: {
          left: '70px',
          // right: '4%',
          bottom: '30px',
          top: '20px'
          // containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.series.dataDate
        },
        yAxis: {
          min: 0,
          max: 100,
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        },
        series: [
          {
            name: this.$t('AllDevices.connectivityHealth2'), // '联网率'
            type: 'line',
            data: this.series.onlineRateDate,
            // data: this.series,
            markPoint: {
              data: [
                // { type: 'max', name: '最大值' }
              ]
            },
            color: colorList[0],
            smooth: false
          }
          
        ]
      }

      this.chart.setOption(option, true)
    }
  }
}
</script>
